import React, { useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const CashfreePayment = () => {
  const [loading, setLoading] = useState(false);

  const handlePayment = async () => {
    setLoading(true);

    try {
      // 1️⃣ Create order in backend
      const res = await axios.post(`${API_URL}/orders`, {
        orderId: `order_${Date.now()}`,
        order_amount: 100, // Example amount
        customer_details: {
          customer_id: "123456",
          customer_name: "John Doe",
          customer_email: "john@example.com",
          customer_phone: "9876543210",
        },
        order_meta: {
          return_url: `${window.location.origin}/payment-success?order_id={order_id}`,
        },
      });

      const { payment_session_id } = res.data;

      if (!payment_session_id) {
        alert("❌ Payment session missing. Check backend response.");
        return;
      }

      // 2️⃣ Load Cashfree Checkout SDK
      const cf = new window.Cashfree(payment_session_id);
      cf.redirect();
    } catch (err) {
      console.error("Payment initiation error:", err.response?.data || err.message);
      alert("❌ Payment initiation failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <button
        onClick={handlePayment}
        disabled={loading}
        style={{
          padding: "12px 24px",
          backgroundColor: "#ff6600",
          color: "#fff",
          border: "none",
          borderRadius: "8px",
          fontSize: "16px",
          cursor: "pointer",
        }}
      >
        {loading ? "Processing..." : "Pay Now"}
      </button>
    </div>
  );
};

export default CashfreePayment;
